"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ImgproxyBuilder = void 0;
var url_join_1 = __importDefault(require("url-join"));
var utils_1 = require("./utils");
var ImgproxyBuilder = /** @class */ (function () {
    function ImgproxyBuilder(config) {
        this.options = {};
        this.config = config;
    }
    ImgproxyBuilder.prototype.resize = function (type, width, height, enlarge) {
        this.setOption('rs', [type, width, height, enlarge ? 1 : 0].join(':'));
        return this;
    };
    ImgproxyBuilder.prototype.size = function (width, height, enlarge) {
        this.setOption('s', [width, height, enlarge ? 1 : 0].join(':'));
        return this;
    };
    ImgproxyBuilder.prototype.resizingType = function (type) {
        this.setOption('rs', type);
        return this;
    };
    ImgproxyBuilder.prototype.width = function (width) {
        this.setOption('w', "" + width);
        return this;
    };
    ImgproxyBuilder.prototype.height = function (height) {
        this.setOption('h', "" + height);
        return this;
    };
    ImgproxyBuilder.prototype.dpr = function (dpr) {
        if (dpr > 0) {
            this.setOption('dpr', "" + dpr);
        }
        return this;
    };
    ImgproxyBuilder.prototype.enlarge = function (enlarge) {
        this.setOption('el', "" + enlarge);
        return this;
    };
    ImgproxyBuilder.prototype.gravity = function (gravity) {
        if ((0, utils_1.isFocusPoint)(gravity)) {
            this.setOption('g', "fp:" + gravity.x + ":" + gravity.y);
        }
        else if ((0, utils_1.isOffsetGravity)(gravity)) {
            this.setOption('g', gravity.type + ":" + gravity.xOffset + ":" + gravity.yOffset);
        }
        else {
            this.setOption('g', gravity);
        }
        return this;
    };
    ImgproxyBuilder.prototype.quality = function (quality) {
        this.setOption('q', "" + quality);
        return this;
    };
    ImgproxyBuilder.prototype.background = function (color) {
        if ((0, utils_1.isRGBColor)(color)) {
            this.setOption('bg', color.r + ":" + color.g + ":" + color.b);
        }
        else {
            this.setOption('bg', color);
        }
        return this;
    };
    ImgproxyBuilder.prototype.blur = function (sigma) {
        this.setOption('bl', "" + sigma);
        return this;
    };
    ImgproxyBuilder.prototype.sharpen = function (sigma) {
        this.setOption('sh', "" + sigma);
        return this;
    };
    ImgproxyBuilder.prototype.watermark = function (opacity, position, offset, scale) {
        this.setOption('wm', opacity + ":" + position + ":" + (offset ? offset.x + ":" + offset.y : '') + ":" + scale);
        return this;
    };
    ImgproxyBuilder.prototype.preset = function () {
        var presets = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            presets[_i] = arguments[_i];
        }
        this.setOption('pr', presets.join(':'));
        return this;
    };
    ImgproxyBuilder.prototype.cacheBuster = function (buster) {
        this.setOption('cb', buster);
        return this;
    };
    ImgproxyBuilder.prototype.format = function (extension) {
        this.setOption('f', extension);
        return this;
    };
    ImgproxyBuilder.prototype.crop = function (width, height, gravity) {
        var crop = width + ":" + height;
        if (gravity) {
            if ((0, utils_1.isFocusPoint)(gravity)) {
                crop = crop + ":fp:" + gravity.x + ":" + gravity.y;
            }
            else if ((0, utils_1.isOffsetGravity)(gravity)) {
                crop = crop + ":" + gravity.type + ":" + gravity.xOffset + ":" + gravity.yOffset;
            }
            else {
                crop = crop + ":" + gravity;
            }
        }
        this.setOption('c', crop);
        return this;
    };
    ImgproxyBuilder.prototype.setOption = function (option, value) {
        this.options[option] = value;
    };
    ImgproxyBuilder.prototype.clearOption = function (option) {
        this.options[option] = undefined;
    };
    /**
     * Generates a URL based on the set options.
     *
     * @param uri The uri of the image
     * @param extension optional string to append as extension
     */
    ImgproxyBuilder.prototype.generateUrl = function (uri, extension) {
        var options = this.serializeOptions();
        var config = this.config;
        var encode = config.encode !== false;
        uri = encode ? (0, utils_1.urlSafeEncode)(uri) : "plain/" + uri;
        uri = extension ? "" + uri + (encode ? '.' : '@') + extension : uri;
        uri = "/" + (options ? options + "/" : '') + uri;
        var signature = (0, utils_1.isSecureConfig)(config)
            ? (0, utils_1.sign)(config.key, config.salt, uri, config.signatureSize || 32)
            : typeof config.insecure === 'string'
                ? config.insecure
                : 'insecure';
        return (0, url_join_1["default"])(config.baseUrl, "" + signature + uri);
    };
    ImgproxyBuilder.prototype.serializeOptions = function () {
        var _this = this;
        return Object.keys(this.options)
            .filter(function (option) { return !!_this.options[option]; })
            .map(function (option) { return option + ":" + _this.options[option]; })
            .join('/');
    };
    return ImgproxyBuilder;
}());
exports.ImgproxyBuilder = ImgproxyBuilder;
